import { BugsnagService, BugsnagServiceModule } from '@b2c/common/services/bugsnag';
import { HelpersServiceModule } from '@b2c/common/services/helpers/helpers.service';
import { ThemesServiceModule } from '@b2c/common/services/themes/themes.service';
import { TODO } from '@b2c/types/utils';
import angular from 'angular';
import uiRouter from 'angular-ui-router';
import { EventsView } from './events';

export default angular.module( 'acme', [
  uiRouter,
  'ngTouch',
  'pascalprecht.translate',
  'acme.templates.app',
  'acme.templates.events',
  ThemesServiceModule,
  EventsView,
  HelpersServiceModule,
  BugsnagServiceModule
])

.config([ '$stateProvider', '$urlRouterProvider', '$locationProvider', '$translateProvider', function AppConfig ( $stateProvider, $urlRouterProvider, $locationProvider, $translateProvider ) {
  $locationProvider.html5Mode({
    enabled: true,
    requireBase: false
  });
  // If 404 App will route to this URL
  $urlRouterProvider.otherwise('/events');

  // Set up l10n strings
//  $translateProvider
//    .useStaticFilesLoader({
//      files: [{
//        prefix: '/assets/assets/lang/',
//        suffix: '.strings'
//      }]
//    })
//    .preferredLanguage('en-US');
}])

.controller( 'AppController', [
  '$window',
  '$scope',
  '$state',
  '$log',
  '$location',
  '$transitions',
  'ThemesService',
  'HelpersService',
  'BugsnagService',
  function AppController(
    $window: TODO,
    $scope: TODO,
    $state: TODO,
    $log: TODO,
    $location: TODO,
    $transitions: TODO,
    ThemesService: TODO,
    HelpersService: TODO,
    bugsnagService: BugsnagService
  ) {

    $scope.app = {

      init: function() {
        $transitions.onSuccess({}, function (transition) {
          var to = transition.to();
          var toParams = transition.params();
          var from = transition.from();
          var fromParams = transition.params('from');

          if ( angular.isDefined( to.data.pageTitle ) ) {
            $scope.pageTitle = to.data.pageTitle + ' - ' + ThemesService.getCompany('name');
            $scope.pageClass = to.data.pageClass;
          }
        });

        $scope.$on('App::UpdateCartItems', this.onUpdateCartItems);
        $scope.$on('App::UpdatePageTitle', this.onUpdatePageTitle);
        $scope.$on('App::NavigationUpdate', this.onNavigationUpdate);
        $scope.$on('App::ToggleNavigation', this.onToggleNavigation);
        $scope.$on('App::HideNavigation', this.onHideNavigation);
        $scope.$on('App::ShowNavigation', this.onShowNavigation);

        $scope.$on('$translateLoadingStart', function() {});
        $scope.$on('$translateLoadingSuccess', function() {});
        $scope.$on('$translateLoadingError', function() {});
        $scope.$on('$translateLoadingEnd', function() {});
      },

      onUpdateCartItems: function(e, data) {
        $scope.$broadcast('Header::UpdateCartItems', data);
      },

      onUpdatePageTitle: function(e, data) {
        $scope.pageTitle = data.title + ' - ' + ThemesService.getCompany('name');
      },

      onNavigationUpdate: function(e, data) {
        console.log('App::onNavigationUpdate', data);

        if (!$scope.pageClass) {
          $scope.pageClass = '';
        }

        if (data.state) {
          $scope.pageClass += ' menu-open';
        }else{
          $scope.pageClass = $scope.pageClass.replace(' menu-open', '');
        }

      },

      onToggleNavigation: function(e, data) {
        console.log('App::onToggleNavigation');
        $scope.$broadcast('MobileNavigation::Toggle', data);
      },

      onHideNavigation: function(e, data) {
        console.log('App::onHideNavigation');
        $scope.$broadcast('MobileNavigation::Hide', data);
      },

      onShowNavigation: function(e, data) {
        console.log('App::onShowNavigation');
        $scope.$broadcast('MobileNavigation::Show', data);
      }

    };

    bugsnagService.start();
    
    $scope.app.init();
}]).name;
